module.exports = __webpack_public_path__ + "img/tv6.7a331f9a.gif";